"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFullscreen = exports.toggleFullscreen = void 0;
var common_sidecar_1 = require("@main/common-sidecar");
var toggleFullscreen = function () {
    common_sidecar_1.common.getPhaserScene().game.scale.toggleFullscreen();
};
exports.toggleFullscreen = toggleFullscreen;
var isFullscreen = function () {
    return common_sidecar_1.common.getPhaserScene().game.scale.isFullscreen;
};
exports.isFullscreen = isFullscreen;
